import { CartLinesUpdateEvent } from '@shopify/events';
import { morphSection } from '@theme/section-renderer';

const SECTION_ID = 'cart-drawer-section';

async function addUpsellProduct(button) {
  const container = button.closest('[data-upsell-product]');
  if (!container) return;

  const productWrap = button.closest('[data-upsell-product]');
  const select = productWrap
    .closest('.cart-drawer-upsell__product, .cart-upsell-section__item')
    ?.querySelector('.cart-upsell__variant-select');

  const variantId = parseInt(
    select ? select.value : (container.dataset.variantId ?? '0'),
    10
  );

  if (!variantId) return;

  button.disabled = true;
  const originalText = button.textContent.trim();
  button.textContent = 'A adicionar...';

  const deferredPromise = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      promise: deferredPromise.promise,
    })
  );

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: SECTION_ID,
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description ?? 'Erro ao adicionar produto');
    }

    const sectionHtml = data.sections?.[SECTION_ID];
    if (sectionHtml) {
      await morphSection(SECTION_ID, sectionHtml, { mode: 'hydration' });
    }

    deferredPromise.resolve({
      cart: data,
      sections: data.sections ?? {},
    });

    resetExpiryTimer();
  } catch (error) {
    console.error('[Cart Upsell]', error);
    deferredPromise.reject(error);
    button.disabled = false;
    button.textContent = originalText;
  }
}

function resetExpiryTimer() {
  const durationEl = document.getElementById('cart-expiry-duration-data');
  const ms = parseInt(durationEl?.dataset.ms ?? '0', 10);
  if (ms > 0) {
    const existing = parseInt(localStorage.getItem('horizonCartExpiry') || '0', 10);
    // Only start if no active timer — the fetch interceptor in cart-drawer handles this too,
    // but this fallback ensures consistency when cart-drawer script is not yet loaded.
    if (existing <= Date.now()) {
      localStorage.setItem('horizonCartExpiry', String(Date.now() + ms));
    }
  }
}

document.addEventListener('click', (event) => {
  const btn = /** @type {HTMLButtonElement | null} */ (
    event.target instanceof Element ? event.target.closest('.cart-upsell__add-btn') : null
  );
  if (!btn) return;
  event.preventDefault();
  addUpsellProduct(btn);
});
